import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, DoCheck } from '@angular/core';
import { SearchTagCheckbox } from '../../model/search';
@Component({
  selector: 'app-select-dropdown',
  templateUrl: './select-dropdown.component.html',
  styleUrls: ['./select-dropdown.component.less']
})
export class SelectDropdownComponent implements OnInit, DoCheck {

  @Input() list: SearchTagCheckbox[];
  @Input() svg: boolean;
  @Input() borderless: boolean;
  @Input() title: string;
  @Output() onSave = new EventEmitter<SearchTagCheckbox[]>();

  isActive: boolean;

  constructor() {
    this.isActive = false;
  }

  ngOnInit() {
    this.isActive = false;
    if (this.list)
      this.list.forEach(element => {
        if (element.checked)
          this.isActive = true;
      });
    $(".checkbox-menu").on("change", "input[type='checkbox']", function () {
      $(this).closest("li").toggleClass("active");
    });
    $(document).on('click', '.allow-focus', function (e) {
      e.stopPropagation();
    });
  }

  ngDoCheck(): void {
    this.isActive = false;
    if (this.list)
      this.list.forEach(element => {
        if (element.checked)
          this.isActive = true;
      });
  }

  onToggle() {
    this.isActive = false;
    if (this.list)
      this.list.forEach(element => {
        if (element.checked)
          this.isActive = true;
      });
    this.onSave.emit(this.list);
  }
}



// WEBPACK FOOTER //
// ./src/app/element/select-dropdown/select-dropdown.component.ts